import { myInput } from './input.js';
import { utils } from './utils.js';
import { historie } from './history.js';
import { doBeading } from './tools/beading.js';
import { drag } from './tools/drag.js';
import { marquee } from './tools/marquee.js';
import { mirror } from './tools/mirror.js';
import { settings } from './settings.js';
import { modes } from './modes.js';
import { palette } from './palette.js';
import { isIOS } from './core/environment.js';

export const beads = {};

export class Bead {
    constructor (row, column) {
        this.row = row;
        this.column = column;
        this.angle = 0;
        this.active = false;
        this.selected = false;
        this.temp = {};
        this.x = 0;
        this.y = 0;
        this.style = null;
        this.ignore = false;
        this.hidden = false;
    }

    setAngle (angle) {
        this.angle = angle;
    }
}


beads.shapes = [
    {
        name: 'round',
        displayName: 'Round',
        shape: 'rectangle',
        width: 60,
        height: 50,
        finishes: ['matte', 'semigloss', 'gloss']
    },
    {
        name: 'cylinder',
        displayName: 'Cylinder',
        shape: 'rectangle',
        width: 60,
        height: 50,
        finishes: ['cylinder_matte', 'cylinder_semigloss', 'cylinder_gloss']
    },
    {
        name: 'plastic',
        displayName: 'Plastic',
        shape: 'rectangle',
        width: 60,
        height: 60,
        finishes: ['plastic']
    }
];

beads.initializeSettings = () => {
    beads.mostRecentClickedBead = null;
    beads.recentlyOverBead = null;
    beads.recentMask = {};
    beads.selectedBeads = [];
    beads.previouslySelectedBeads = [];
    beads.arr = [];
    beads.resetRowOffset();
    if (beads.mirror !== undefined) {
        beads.mirror.active = false;
        beads.mirror.forEach(mirror => {
            mirror.setAngle(0).setAlpha(0).setFillStyle(0xff0000);
        });
    }
};

beads.resetRowOffset = () => {
    beads.rowOffset = [];
    for (let i = 0; i < settings.rows; i++) {
        beads.rowOffset.push(null);
    };
};

beads.truncateRowOffset = () => {
    beads.rowOffset = beads.rowOffset.slice(0, settings.rows);
};

beads.newProject = () => {
    beads.initializeSettings();
    beads.createRT();

    const myAngle = (settings.pattern.rotateCamera) ? -90 : 0;
    beads.cursor.text.setAngle(myAngle);
    beads.cursor.shape.height = settings.beadDisplayHeight;
    beads.cursor.secondShape.height = settings.beadDisplayHeight;

    // create array of beads

    if (settings.pattern.create !== undefined) {
        settings.pattern.create();
    } else {
        for (let i = 0; i < settings.columns; i++) {
            for (let j = 0; j < settings.rows; j++) {
                beads.arr.push(new Bead(j, i));
            }
        }
    }
};

beads.createRT = () => {

    if (beads.rt !== undefined) {
        beads.rt.forEach(element => element.canvas.destroy());
    }
    beads.rt = [];

    let rowDist = settings.pattern.rowDist();
    let colDist = settings.pattern.colDist();

    beads.canvasSize = {
        width: 2500,
        height: 2500
    };

    if (settings.pattern.useSingleRenderTexture) {
        beads.rt.push({
            column: 0,
            row: 0,
            canvas: game.add.renderTexture(0, 0, 2500, 2500).setOrigin(0).myIgnore('top')
        });
        return;
    }

    if (settings.pattern.useFourRenderTextures) {
        beads.rt.push({
            column: 0,
            row: 0,
            canvas: game.add.renderTexture(0, 0, 2500, 2500).setOrigin(0).myIgnore('top')
        });
        beads.rt.push({
            column: 0,
            row: 1,
            canvas: game.add.renderTexture(0, 2500, 2500, 2500).setOrigin(0).myIgnore('top')
        });
        beads.rt.push({
            column: 1,
            row: 0,
            canvas: game.add.renderTexture(2500, 0, 2500, 2500).setOrigin(0).myIgnore('top')
        });
        beads.rt.push({
            column: 1,
            row: 1,
            canvas: game.add.renderTexture(2500, 2500, 2500, 2500).setOrigin(0).myIgnore('top')
        });
        return;
    }

    let projectWidth = 100 + (settings.columns * colDist);
    let projectHeight = 100 + (settings.rows * rowDist);
    let rowsNeeded = Math.floor((projectHeight + (beads.canvasSize.height-1)) / beads.canvasSize.height);
    let columnsNeeded = Math.floor((projectWidth + (beads.canvasSize.width-1)) / beads.canvasSize.width);
    let finalColWidth = projectWidth - ((columnsNeeded - 1) * beads.canvasSize.width);
    let finalRowHeight = projectHeight - ((rowsNeeded - 1) * beads.canvasSize.height);

    for (let i = 0; i < rowsNeeded * columnsNeeded; i++) {
        let element = {
            column: Math.floor(i / rowsNeeded),
            row: i % rowsNeeded,
        };

        let y = element.row * beads.canvasSize.height, x = element.column * beads.canvasSize.width;
        let w = (element.column == (columnsNeeded - 1)) ? finalColWidth : beads.canvasSize.width + 50;
        let h = (element.row == (rowsNeeded - 1)) ? finalRowHeight : beads.canvasSize.height + 50;

        w = Math.floor(w);
        h = Math.floor(h);

        element.canvas = game.add.renderTexture(x, y, w, h).setOrigin(0).myIgnore('top');

        beads.rt.push(element);
    }
};

beads.initialize = () => {

    beads.initializeSettings();

    // cursor

    beads.cursor = {
        shape: game.add.rectangle(0, 0, 60, settings.beadDisplayHeight, 0xd5dde5, 1).setVisible(false).setOrigin(0.5).myIgnore('top'),
        ellipse: game.add.ellipse(0, 0, 36, 36, 0xd5dde5, 1).setVisible(false).setOrigin(0.5).myIgnore('top'),
        selector: game.add.ellipse(0, 0, 8, 8, 0x000000, 1).setStrokeStyle(2, 0xffffff, 1).setVisible(false).setOrigin(0.5).myIgnore('top'),
        dot: game.add.ellipse(0, 0, 8, 8, 0x000000, 1).setVisible(false).setOrigin(0.5).myIgnore('top'),
        finish: game.add.image(0, 0, 'matte').setVisible(false).setOrigin(0.5).myIgnore('top'),
        secondShape: game.add.rectangle(0, 0, 60, settings.beadDisplayHeight, 0xd5dde5, 1).setVisible(false).setOrigin(0.5).setBlendMode(2).myIgnore('top'),
        text: game.add.text(0,0, '', {fontFamily: 'Verdana', fontSize: '20px', color: '#FFF'}
        ).setOrigin(0.5).myIgnore('top'),
        setVisible: arg => ['shape', 'secondShape', 'finish', 'text'].forEach(attr =>
            beads.cursor[attr].setVisible(arg)),
        setAngle: angle => ['shape', 'secondShape', 'finish'].forEach(attr =>
            beads.cursor[attr].setAngle(angle)),
    };

    // marquee

    beads.marquee = game.add.rectangle(0,0,10,10,0xFF0000).setAlpha(0).setOrigin(0).setDepth(0.5).myIgnore('top');

    // mirror

    beads.mirror = [
        game.add.rectangle(600,400,4,10000,0xFF0000).setAlpha(0).setOrigin(0.5).setDepth(0.1).myIgnore('top'),
        game.add.rectangle(600,400,10000,4,0xFF0000).setAlpha(0).setOrigin(0.5).setDepth(0.1).myIgnore('top'),
        game.add.rectangle(600,400,4,10000,0xFF0000).setAlpha(0).setOrigin(0.5).setDepth(0.1).myIgnore('top'),
    ];

    beads.mirror.active = false;
    beads.mirror.orientation = 'vertical';

    // co-ordinates


    // canvas

    beads.resize = () => {
        // update the clickable area
        beads.canvas.width = game.scale.width;
        beads.canvas.height = game.scale.height;
    };

    beads.addCanvas = () => {
        beads.canvas = game.add.rectangle(0, 0, game.scale.width, game.scale.height, 0x000000, 0.01).setDepth(0).setOrigin(0).setInteractive().myIgnore();
        beads.canvas.on('pointerdown', () => {
            if (b3.store.state.hasBooted) beads.processClick();
        }).on('pointermove', () => {
            if (b3.store.state.hasBooted) beads.processMove();
        }).on('pointerup', () => {
            if (b3.store.state.hasBooted) {
                if (modes.currentMode.name === 'draw' || (modes.currentMode.name === 'erase')) {
                    historie.addAction();
                }
            }
        });
    };

    beads.addCanvas();
};

beads.processClick = () => {
    if (game.input.activePointer.position.x < 83) return;
    if (game.input.activePointer.position.y < 51) return;
    const myBead = beads.beadFromPoint();

    if (myBead) {
        beads.mostRecentClickedBead = myBead;
        beads.recentlyOverBead = myBead;
        modes.clickBead(myBead);
    } else {
        modes.clickCanvas();
    }
};

beads.beadFromPoint = () => {
    let myPoint = utils.returnPoint(game.input.activePointer.position.x, game.input.activePointer.position.y);

    if (settings.pattern.beadFromPoint) {
        for (let i = 0; i < beads.arr.length; i++) {
            if (Math.abs(beads.arr[i].x - myPoint.x) < 18
            && (Math.abs(beads.arr[i].y - myPoint.y) < 15)
            && (!beads.arr[i].hidden)
            ){
                if (beads.arr[i].ignore) return;
                return beads.arr[i];
            }
        }
    } else {
        let yDist = settings.pattern.rowDist();
        let xDist = settings.pattern.colDist();

        let myRow, myCol;
        myRow = Math.floor((myPoint.y - 100 + (yDist/2)) / yDist);
        myCol = Math.floor((myPoint.x - 100 + (xDist/2) + (beads.rowOffset[myRow] * (xDist/2))) / xDist);

        if (myRow < settings.rows && (myCol < settings.columns)) {
            let myBead = beads.findBead(myCol, myRow);
            if (myBead === undefined) return;
            if (myBead.ignore) return;
            return myBead;
        }
    }
};

beads.setCoordinates = bead => {

    let row = bead.row;
    let column = bead.column;

    if (settings.pattern.getCoordinates) {
        [row, column] = settings.pattern.getCoordinates(bead);
    }

    const str = settings.pattern.noCoordinates ? '' : `(${row + 1}, ${column + 1})`;
    b3.store.mySet('coordinates', str);
};


beads.processMove = () => {
    if (game.input.activePointer.position.x < 83) return;
    if (game.input.activePointer.position.y < 51) return;
    const myBead = beads.beadFromPoint();
    if (!myBead) return;

    beads.setCoordinates(myBead);

    const buttonDown = b3.primaryMouseButtonDown || (isIOS && game.input.activePointer.isDown);

    if (!buttonDown) return;
    if (!modes.currentMode.overBead) return;
    if (myBead === beads.recentlyOverBead) return;

    modes.overBead(myBead);
    beads.recentlyOverBead = myBead;
};

beads.buildRender = (bead, rt, simple, inner, infix, place, tempShift, myScale) => {

    if (rt.canvas?.height == 50) { // targets prototype bead
        tempShift *= 1.5
    }

    // draw the main color of the bead

    if (settings.library.shape === 'plastic') {
        beads.cursor.ellipse.setFillStyle(bead.fillColor);
        rt.draw(beads.cursor.ellipse, place.x, place.y);
    } else {
        beads.cursor.shape.setFillStyle(bead.fillColor);
        rt.draw(beads.cursor.shape, place.x, place.y + tempShift);
    }

    if (!simple) {

        if (settings.library.shape !== 'plastic') {
            beads.cursor.finish.setScale(myScale, myScale * (settings.beadDisplayHeight / 50)).setAngle(bead.angle);
        }

        // draw inside color if it exists
        if (inner == 'insidecolor') {
            beads.cursor.finish.setTexture(infix + 'insidecolor');
            rt.draw(beads.cursor.finish, place.x, place.y);
        }

        // draw transparency
        if (inner !== 'opaque') {
            beads.cursor.finish.setTexture(infix + 'transparent').setAlpha(0.8).setBlendMode(4);
            rt.draw(beads.cursor.finish, place.x, place.y);
            beads.cursor.finish.setBlendMode(Phaser.BlendModes.NORMAL).setAlpha(1);
        }

        // draw the exterior texture
        if (settings.library.shape === 'plastic') {
            rt.draw(beads.cursor.dot, place.x, place.y);
        } else {
            beads.cursor.finish.setTexture(bead.finishName);
            rt.draw(beads.cursor.finish, place.x, place.y);
        }

        // draw secondary color
        if (bead.secondColor) {
            beads.cursor.secondShape.setFillStyle(bead.secondColor)
            .setScale(myScale).setAngle(bead.angle);
            rt.draw(beads.cursor.secondShape, place.x, place.y + tempShift);
        }

        // draw corners
        if (infix == 'round_') {
            beads.cursor.finish.setTexture(settings.theme.cornersTexture);
            rt.draw(beads.cursor.finish, place.x, place.y);
        }
    }
};

beads.render = (bead, rt='main canvas') => {
    if (bead.ignore) return;
    if (bead.hidden) return;

    let simple = settings.renderColorOnly;

    let place = {x: bead.x, y: bead.y};

    let tempShift = (settings.beadDisplayHeight - 50) * (-3/10);

    let extraRT = {
        left: null,
        right: null,
        above: null,
        below: null,
    };

    if (rt === 'main canvas') {
        // work out which RT to draw on
        let myCol = Math.floor(bead.x / beads.canvasSize.width);
        let myRow = Math.floor(bead.y / beads.canvasSize.height);

        if (beads.rt.length > 1) {
            let obj = beads.rt.find(element => element.row === myRow && (element.column === myCol));
            if (!obj) return;
            rt = obj.canvas;
        } else {
            rt = beads.rt[0].canvas;
        }

        place = {
            x: bead.x - rt.x,
            y: bead.y - rt.y
        };

        // do we need to draw on another canvas? (cover seams)
        if (place.x > 2450) {
            let obj = beads.rt.find(element => element.row == myRow && (element.column == myCol + 1));
            if (obj !== undefined) extraRT.right = obj.canvas;
        }
        if (place.y > 2450) {
            let obj = beads.rt.find(element => (element.row == myRow + 1) && (element.column == myCol));
            if (obj !== undefined) extraRT.below = obj.canvas;
        }
        if (place.x < 50) {
            let obj = beads.rt.find(element => element.row == myRow && (element.column == myCol - 1));
            if (obj !== undefined) extraRT.left = obj.canvas;
        }
        if (place.y < 50) {
            let obj = beads.rt.find(element => (element.row == myRow - 1) && (element.column == myCol));
            if (obj !== undefined) extraRT.above = obj.canvas;
        }
    }

    let myScale = bead.scale || 0.6;
    let inner = bead.inner || 'opaque';

    let infix = (settings.library.shape === 'cylinder') ? 'cylinder_' : 'round_';
    if (settings.library.shape === 'plastic') infix = '';

    beads.cursor.shape.setVisible().setAngle(bead.angle).setScale(myScale).setFillStyle(settings.theme.inactiveBead, 1);

    let myDraw = (obj, shift=0) => {
        rt.draw(obj, place.x, place.y + shift);
        [
            {direction: 'right', deltaX: -2500, deltaY: 0},
            {direction: 'left', deltaX: 2500, deltaY: 0},
            {direction: 'below', deltaX: 0, deltaY: -2500},
            {direction: 'above', deltaX: 0, deltaY: 2500},
        ].forEach(element => {
            if (extraRT[element.direction]) {
                extraRT[element.direction].draw(obj, place.x + element.deltaX, place.y + element.deltaY + shift);
            }
        });
    };

    if (!bead.active) {
        if (settings.showInactiveBeads) {
            if (settings.library.shape === 'plastic') {
                beads.cursor.ellipse.setFillStyle(settings.theme.inactiveBead, 1).setScale(1);
                myDraw(beads.cursor.ellipse);
            } else {
                beads.cursor.shape.setBlendMode(Phaser.BlendModes.ERASE).setScale(myScale * 1.1);
                myDraw(beads.cursor.shape);
                beads.cursor.shape.setBlendMode(Phaser.BlendModes.NORMAL).setScale(myScale);
                myDraw(beads.cursor.shape);
            }
        }
    } else {
        if (bead.style === undefined) {
            // creating new render (palette, prototype bead, finish pickers)
            beads.buildRender(bead, rt, simple, inner, infix, place, tempShift, myScale);
        } else {
            // drawing beads on canvas

            let mySwatch = b3.store.state.swatches.find(element => element.id === bead.style);

            if (mySwatch === undefined) { // no swatch found! error!
                beads.cursor.setVisible(false);
                console.error(bead);
                bead.style = null;
                bead.active = false;
                return;
            }

            if (settings.library.shape === 'plastic') {
                beads.cursor.ellipse.setFillStyle(mySwatch.fillColor).setScale(0.97);
                myDraw(beads.cursor.ellipse);
                if (!simple && !bead.selected) {
                    myDraw(beads.cursor.dot);
                }
            } else {
                mySwatch.rt.setAngle(bead.angle);
                myDraw(mySwatch.rt, -tempShift); // SAFARI DEBUG ONLY
                mySwatch.rt.setAngle(0);
            }

            // draw letter code

            if (mySwatch.letterCode && settings.showLetterCodes) {
                let myColor = utils.colorToHex(mySwatch.fillColor);
                let whiteOrBlack = utils.isHexLight(myColor) ? '#000' : '#FFF';
                beads.cursor.text.setText(mySwatch.letterCode).setColor(whiteOrBlack);
                if (settings.library.shape === 'plastic') {
                    myDraw(beads.cursor.text);
                } else {
                    myDraw(beads.cursor.text, -tempShift);
                }
            }

            // draw selection box

            if (bead.selected) {
                if (settings.library.shape === 'plastic') {
                    beads.cursor.ellipse.setFillStyle(0xffffff, 0.8).setBlendMode(4);
                    myDraw(beads.cursor.ellipse);
                    beads.cursor.ellipse.setBlendMode(Phaser.BlendModes.NORMAL);
                } else {
                    beads.cursor.shape.setFillStyle(0xffffff, 0.8).setBlendMode(4);
                    myDraw(beads.cursor.shape);
                    beads.cursor.shape.setBlendMode(Phaser.BlendModes.NORMAL);
                    myDraw(beads.cursor.selector);
                }
            }

            // translucent cover in beading mode

            if (modes.currentMode.name == 'beading') {
                if (!doBeading.shouldHighlight(bead)) {
                    if (settings.library.shape === 'plastic') {
                        beads.cursor.ellipse.setFillStyle(0xffffff, 0.7);
                        myDraw(beads.cursor.ellipse);
                    } else {
                        beads.cursor.shape.setScale(myScale).setFillStyle(0xffffff, 0.7);
                        myDraw(beads.cursor.shape);
                    }
                }
            }
        }
    }

    beads.cursor.setVisible(false);
};

beads.refreshCanvas = () => {
    if (!beads.rt) return;
    beads.rt.forEach(element => element.canvas.clear()); // Phaser 3.51

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.hidden) return;
        if (bead.active) {
            beads.render(bead);
        } else {
            beads.erase(bead);
        }
    });

};

beads.findBead = (i, j) => settings.pattern.manualFindBead ?
    beads.arr.find(element => (element.row === j) && (element.column === i)):
    beads.arr[(i * settings.rows) + j];

beads.addColor = bead => {
    if (bead.ignore) return;
    if (bead.hidden) return;
    if (b3.store.state.beadSoupActive && palette.beadSoup.length) {
        const rand = Math.floor(Math.random() * palette.beadSoup.length);
        bead.style = palette.beadSoup[rand];
    } else {
        if (typeof palette.activeStyleId !== 'number') return;
        bead.style = palette.activeStyleId;
    }
    bead.active = true;
    beads.render(bead);
};

beads.draw = bead => {
    if (!myInput.pointerEnabled) return;
    if (myInput.SHIFT.isDown) {
        beads.useEraser(bead);
    } else if (myInput.ALT.isDown) {
        let myMode = modes.arr.find(element => element.name === 'eyedropper');
        myMode.onClickBead(bead);
    } else {
        beads.addColor(bead);
        if (beads.mirror.active) {
            const mirrorBead = mirror.findMirrorBead(bead);
            if (!Array.isArray(mirrorBead)) return;
            mirrorBead.forEach(_bead => {
                if (!_bead) return;
                beads.addColor(_bead);
            });
        }
    }
};

beads.useEraser = bead => {
    if (!settings.showInactiveBeads) {
        settings.showInactiveBeads = true;
        beads.refreshCanvas();
    }
    beads.erase(bead);
    if (beads.mirror.active) {
        const mirrorBead = mirror.findMirrorBead(bead);
        if (!Array.isArray(mirrorBead)) return;
        mirrorBead.forEach(_bead => {
            if (!_bead) return;
            if (!_bead.active) return;
            beads.erase(_bead);
        });
    }
};

beads.erase = bead => {
    if (bead.ignore) return;
    if (bead.hidden) return;
    if (bead.selected) {
        beads.unselect(bead);
    }
    bead.style = null;
    bead.active = false;
    beads.render(bead);
};

beads.eraseSelected = () => {
    if (!settings.showInactiveBeads) {
        settings.showInactiveBeads = true;
        beads.refreshCanvas();
    }
    let actionHappened = false;
    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.hidden) return;
        if (bead.selected) {
            beads.erase(bead);
            actionHappened = true;
        }
    });
    if (actionHappened) {
        historie.addAction();
    }
};

beads.useMarqueeTool = bead => {
    if (bead.active && bead.selected) {
        drag.start();
    } else {
        marquee.launch();
    }
};

beads.useSelectTool = bead => {
    if (bead.active) {
        if (bead.selected) { // if the bead is already selected, go to drag mode or deselect
            if (myInput.SHIFT.isDown) {
                beads.toggleSelect(bead);
            } else {
                drag.start();
            }
        } else {
            beads.toggleSelect(bead);
        }
    } else {
        beads.unselectAll();
    }
};

beads.select = bead => {
    if (!bead.selected) {
        bead.selected = true;
        beads.render(bead);
    }
};

beads.unselect = bead => {
    if (bead.selected) {
        bead.selected = false;
        beads.render(bead);
    }
};

beads.toggleSelect = bead => {
    if (bead.active) {
        if (myInput.SHIFT.isDown) {
            beads.unselect(bead);
        } else {
            beads.select(bead);
        }
    }
};

beads.useWandTool = bead => {
    if (bead.active) {
        if (bead.selected) { // if the bead is already selected, go to drag mode
            drag.start();
        } else {
            beads.selectAll(bead);
        }
    } else {
        beads.unselectAll();
    }
};

beads.selectAll = bead => {
    beads.unselectAll();
    beads.arr.forEach(_bead => {
        if (_bead.ignore || _bead.hidden) return;
        if (_bead.active && _bead.style === bead.style) {
            beads.select(_bead);
        }
    })
};

beads.unselectAll = () => {
    beads.arr.forEach(bead => {
        if (bead.ignore || bead.hidden) return;
        beads.unselect(bead);
    });
};

beads.changeColor = () => {
    let madeChange = false;
    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.hidden) return;
        if (bead.selected) {
            bead.style = palette.activeStyleId;
            beads.render(bead);
            madeChange = true;
        }
    });
    if (madeChange) historie.addAction();
};

beads.assign = (a, b, willRender=false) => {
    if (a.ignore) return;
    a.style = b.style;
    a.active = b.active;
    a.selected = b.selected;

    if (willRender) beads.render(a);
};

beads.rowShift = bead => {
    if (beads.rowOffset[bead.row]) {
        beads.rowOffset[bead.row] = 0;
        beads.arr.forEach(_bead => {
            if (_bead.ignore) return;
            if (_bead.row == bead.row) {
                _bead.x += 19;
            }
        });
    } else {
        beads.rowOffset[bead.row] = 1;
        beads.arr.forEach(_bead => {
            if (_bead.ignore) return;
            if (_bead.row == bead.row) {
                _bead.x -= 19;
            }
        });
    }
    historie.addAction();
    beads.refreshCanvas();
};

beads.getBeadCount = () => {

    let myBeadCount = 0;
    beads.arr.forEach(bead => {
        if (!bead.ignore && bead.active) myBeadCount++;
    });

    return myBeadCount;
};

beads.copy = () => {
    if (settings.pattern.noDrag) return;
    beads.clipboard = {
        swatch: [],
        beads: [],
        beadShape: settings.library.shape
    };
    beads.arr.forEach(bead => {
        if (bead.selected) {
            let mySwatch = b3.store.state.swatches.find(element => element.id === bead.style);

            if (!beads.clipboard.swatch.some(element => element.id === mySwatch.id)) {
                beads.clipboard.swatch.push({
                    fillColor: mySwatch.fillColor,
                    secondColor: mySwatch.secondColor,
                    description: mySwatch.description,
                    finishName: mySwatch.finishName,
                    inner: mySwatch.inner,
                    id: mySwatch.id,
                });
            }

            beads.clipboard.beads.push({
                row: bead.row,
                column: bead.column,
                style: bead.style,
            });
        }
    });
};

beads.paste = () => {
    if (!settings.pattern.noDrag && beads.clipboard) {

        // add swatches

        beads.clipboard.swatch.forEach(swatch => {

            let myFinishName = utils.convertFinishName(swatch.finishName);

            if (settings.library.shape === 'plastic') {
                myInner = 'opaque';
                mySecondColor = null;
            }

            const myNewSwatch = palette.addSwatch({
                fillColor: swatch.fillColor,
                description: swatch.description,
                finishName: myFinishName,
                inner: swatch.inner,
                secondColor: swatch.secondColor
            });

            // re-assign beads new style (id)

            beads.clipboard.beads.forEach(bead => {
                if (bead.style == swatch.id) {
                    bead.newStyle = myNewSwatch.id;
                }
            })
        });

        // now add the beads

        beads.clipboard.beads.forEach(bead => {
            let myBead = beads.arr.find(element => element.row == bead.row && (element.column == bead.column));
            if (myBead) {
                myBead.style = bead.newStyle;
                myBead.active = true;
                beads.render(myBead);
            }
        });
        historie.addAction();
    }
};